
import { useSEO } from '../../hooks/useSEO';

export default function AGBPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'AGB - Bamme-Media',
    description:
      'Allgemeine Geschäftsbedingungen von Bamme-Media für Webdesign und Online Marketing Dienstleistungen.',
    keywords:
      'AGB, Geschäftsbedingungen, Bamme-Media, Webdesign, Online Marketing',
    canonical: `${siteUrl}/agb`,
    robots: 'noindex, nofollow, noarchive, nosnippet',
    ogTitle: 'AGB | Bamme-Media',
    ogDescription:
      'Allgemeine Geschäftsbedingungen von Bamme-Media für Webdesign und Online Marketing Dienstleistungen.',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Allgemeine Geschäftsbedingungen',
      description: 'Allgemeine Geschäftsbedingungen von Bamme-Media',
      url: `${siteUrl}/agb`,
      isPartOf: {
        '@type': 'WebSite',
        name: 'Bamme-Media',
        url: siteUrl,
      },
      about: {
        '@type': 'TermsOfService',
        name: 'AGB Bamme-Media',
      },
    },
  });

  const agbContent = `🧾 Allgemeine Geschäftsbedingungen (AGB) – Bamme Media
Stand: Oktober 2025

§1 Geltungsbereich
(1) Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen Bamme Media, Inhaber Dion Bamme, (nachfolgend „ich" oder „Bamme Media") und dem jeweiligen Auftraggeber (nachfolgend „Kunde" genannt).
(2) Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, ich stimme ihnen ausdrücklich schriftlich zu.
(3) Diese AGB gelten sowohl für Verbraucher (§13 BGB) als auch für Unternehmer (§14 BGB), soweit keine spezielleren Regelungen vereinbart sind.

§2 Leistungsangebot
(1) Bamme Media bietet Dienstleistungen in den Bereichen
Webdesign und Website-Erstellung (auch mit KI-Tools wie Readdy.ai),
Hosting und technische Betreuung,
Online-Marketing, SEO und Social Media Betreuung,
Content-Erstellung (Texte, Grafiken, Fotos, Videos)
an.
(2) Der genaue Leistungsumfang ergibt sich jeweils aus dem individuellen Angebot oder der Auftragsbestätigung.
(3) Nachträgliche Änderungen oder Zusatzleistungen werden gesondert berechnet und bedürfen einer schriftlichen Vereinbarung.

§3 Vertragsschluss
(1) Ein Vertrag kommt zustande, sobald der Kunde ein Angebot von Bamme Media schriftlich oder per E-Mail bestätigt oder ich mit der Ausführung beginne.
(2) Angebote sind grundsätzlich freibleibend, bis sie vom Kunden angenommen werden.
(3) Änderungen oder Nebenabreden bedürfen der Schriftform (E-Mail genügt).

§4 Preise und Zahlungsbedingungen
(1) Alle angegebenen Preise sind Endpreise. Als Kleinunternehmer im Sinne von §19 UStG weise ich keine Umsatzsteuer aus.
(2) Zahlungen sind innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug fällig.
(3) Bei größeren Projekten kann ich Teilzahlungen verlangen (z. B. 50 % bei Auftragserteilung, 50 % nach Fertigstellung).
(4) Bis zur vollständigen Bezahlung bleiben alle erstellten Werke (Websites, Designs, Daten, Zugänge) Eigentum von Bamme Media.
(5) Gerät der Kunde in Zahlungsverzug, bin ich berechtigt, Leistungen auszusetzen oder Zugänge zu sperren, bis die Zahlung eingegangen ist.

§5 Mitwirkungspflichten des Kunden
(1) Der Kunde stellt alle für die Leistungserbringung erforderlichen Inhalte, Texte, Bilder, Logos, Passwörter, Zugänge und Informationen rechtzeitig zur Verfügung.
(2) Verzögert sich das Projekt durch fehlende Mitwirkung, verlängern sich die vereinbarten Fristen entsprechend.
(3) Der Kunde ist für die rechtliche Zulässigkeit der von ihm bereitgestellten Inhalte selbst verantwortlich (z. B. Urheberrechte, Markenrechte, Impressumspflicht).
(4) Bamme Media übernimmt keine Haftung für rechtliche Verstöße durch Inhalte, die vom Kunden stammen.

§6 Nutzungsrechte
(1) Nach vollständiger Bezahlung erhält der Kunde das einfache, nicht übertragbare Nutzungsrecht an der erstellten Website oder den erstellten Inhalten.
(2) Das Urheberrecht verbleibt bei Bamme Media (Dion Bamme), sofern nichts anderes vereinbart wurde.
(3) Eine Weitergabe, Veränderung oder der Weiterverkauf der erstellten Werke ohne schriftliche Zustimmung ist nicht gestattet.
(4) Bis zur vollständigen Zahlung bleibt die Nutzung der Website oder Medieninhalte nur vorläufig gestattet.

§7 Hosting und technische Umsetzung
(1) Wenn das Hosting über Bamme Media oder über einen Drittanbieter erfolgt (z. B. Readdy.ai, GoDaddy, Ionos etc.), gelten zusätzlich deren Bedingungen.
(2) Ich hafte nicht für technische Ausfälle, Serverprobleme, Datenverluste oder Einschränkungen, die durch Dritte verursacht werden.
(3) Auf Wunsch kann das Hosting oder die Domain auf den Kunden übertragen werden. In diesem Fall endet meine technische Verantwortung.
(4) Regelmäßige Backups und Updates werden – sofern vereinbart – durchgeführt, garantieren jedoch keine vollständige Datensicherung.

§8 Laufzeit, Kündigung und Projektende
(1) Projektverträge enden automatisch mit der vollständigen Erbringung der vereinbarten Leistung.
(2) Laufende Verträge (z. B. Hosting, Betreuung, Social Media) können mit einer Frist von 4 Wochen zum Monatsende gekündigt werden.
(3) Eine fristlose Kündigung aus wichtigem Grund bleibt möglich (z. B. bei Zahlungsverzug oder Pflichtverletzung).
(4) Nach Beendigung des Vertrags werden Kundendaten auf Wunsch gelöscht, soweit keine gesetzlichen Aufbewahrungspflichten bestehen.

§9 Gewährleistung und Haftung
(1) Ich verpflichte mich, alle Leistungen sorgfältig und nach aktuellem technischem Stand zu erbringen.
(2) Kleinere Abweichungen in Design, Funktion oder Darstellung gelten nicht als Mängel, solange sie den Zweck der Website nicht beeinträchtigen.
(3) Für Schäden, die durch Dritte, durch fehlerhafte Inhalte des Kunden oder durch höhere Gewalt entstehen, wird keine Haftung übernommen.
(4) Die Haftung ist auf den vorhersehbaren, typischerweise eintretenden Schaden und höchstens auf den Auftragswert begrenzt.
(5) Eine Haftung für entgangenen Gewinn oder Folgeschäden wird ausgeschlossen.

§10 Referenznennung
(1) Ich bin berechtigt, erstellte Websites, Designs oder Kampagnen als Referenzen auf meiner Website, in Social Media oder in Präsentationen zu verwenden.
(2) Der Kunde kann der Referenznennung jederzeit widersprechen.

§11 Datenschutz
(1) Alle personenbezogenen Daten werden gemäß der Datenschutz-Grundverordnung (DSGVO) verarbeitet.
(2) Details zur Datenverarbeitung finden sich in der Datenschutzerklärung.

§12 Schlussbestimmungen
(1) Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.
(2) Gerichtsstand ist der Sitz von Bamme Media, soweit gesetzlich zulässig.
(3) Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.

Kontakt:
Bamme Media
Inhaber: Dion Bamme
E-Mail: info@bamme-media.de`;

  const formatContent = (content: string) => {
    return content.split('\n').map((line, index) => {
      if (line.startsWith('🧾')) {
        return (
          <h1
            key={index}
            className="text-3xl font-bold text-[#d1bc8a] mb-8 text-center"
          >
            {line.replace('🧾 ', '')}
          </h1>
        );
      }
      if (line.startsWith('§')) {
        return (
          <h2
            key={index}
            className="text-xl font-semibold text-white mt-8 mb-4"
          >
            {line}
          </h2>
        );
      }
      if (line.startsWith('Stand:') || line.startsWith('Kontakt:')) {
        return (
          <p key={index} className="text-[#d1bc8a] font-medium mb-4">
            {line}
          </p>
        );
      }
      if (line.trim() === '') {
        return <br key={index} />;
      }
      return (
        <p key={index} className="text-gray-300 mb-2 leading-relaxed">
          {line}
        </p>
      );
    });
  };

  return (
    <div className="min-h-screen bg-gray-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#d1bc8a]/20 to-transparent"></div>
        <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml,%3Csvg width=%2260%22 height=%2260%22 viewBox=%220%200%2060%2060%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cg fill=%22%23d1bc8a%22 fill-opacity=%220.1%22%3E%3Ccircle cx=%2230%22 cy=%2230%22 r=%222%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-30"></div>
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/40 z-10"></div>

      {/* Content */}
      <div className="relative z-20 pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          {/* Header */}
          <div className="mb-12">
            <h1 className="text-4xl font-bold text-white mb-4">
              Allgemeine Geschäftsbedingungen
            </h1>
            <p className="text-gray-300 text-lg">
              Rechtliche Grundlagen für unsere Zusammenarbeit
            </p>
          </div>

          {/* Content Area */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="prose prose-invert max-w-none">
              {formatContent(agbContent)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
